import React from 'react';
import {Heading, SimpleGrid, VStack, useColorModeValue } from '@chakra-ui/react';
import VideoCard from './VideoCard';

const VideoSection = ({ videos }) => {
  const headingColor = useColorModeValue('brand.accent', 'brand.accent');

  return (
    <VStack spacing={8} align="stretch" px={{ base: 4, md: 8, lg: 12 }}>
      <Heading
        as="h2"
        size={{ base: "xl", md: "2xl" }}
        textAlign="center"
        color={headingColor}
        pb={4}
        borderBottom="2px solid"
        borderColor="brand.700"
        mx="auto"
        maxW="fit-content"
        borderRadius="md"
        px={4}
      >
        My Videos
      </Heading>
      <SimpleGrid
        columns={{ base: 1, sm: 2, md: 3 }} // Responsive grid columns for videos
        spacing={8}
        justifyItems="center"
      >
        {videos && videos.map((video) => ( // Ensure videos array exists before mapping
          <VideoCard key={video.id} video={video} />
        ))}
      </SimpleGrid>
    </VStack>
  );
};

export default VideoSection;